import React from 'react';
import { formatMoney } from '@/common/client';
import { TicketFooterRow } from './TicketFooter';

function StakeDetailNg({ spent, saved, fees }) {
    if (!spent || !fees) {
    }
    return (
        <div className="ticket-detail-footer-stake-detail">
            {!saved && fees ? (
                <TicketFooterRow rowInfo={formatMoney(spent, 'EUR')} rowTitle="ticketus.ticket.betslipSpent" />
            ) : null}
            {fees ? <TicketFooterRow rowInfo={formatMoney(fees, 'EUR')} rowTitle="ticketus.ticket.fees" /> : null}
        </div>
    );
}

export default StakeDetailNg;
